import React from 'react';
import './SortPage.css';
import '@shopify/polaris/dist/styles.css';
import Sort from '../components/Sort';
import AuthenticatedPage from '../components/AuthenticatedPage';

interface SortPageProps {
  id: string;
  match: any;
}

function SortPage(props: SortPageProps) {
  return (
    <AuthenticatedPage>
      {shopOrigin => <Sort shopOrigin={shopOrigin} type="existing" id={props.match.params.sortId} />}
    </AuthenticatedPage>
  );
}

export default SortPage;
